import axios from 'axios';

const SERVICES_PREFIX = '/services';
const USE_SERVICES = '/lorawan';

const resolveBaseURL = (): string => {
  const { origin: fallbackBaseURL, hostname } = window.location;
  const isLocalhost = hostname === 'localhost';
  return (
    (isLocalhost ? process.env.REACT_APP_ROOT_URL : null) ?? fallbackBaseURL
  );
};

const baseURL = resolveBaseURL();
const normalizeUrl = (url: string) => url?.replace(/\/$/, '');

const joinUrl = (base: string, path: string) =>
  `${normalizeUrl(base)}${path.startsWith('/') ? '' : '/'}${path}`;

export const getApiBaseURL = (realm?: string, path?: string) => {
  const isServicesPath = path?.startsWith(USE_SERVICES);
  if (isServicesPath) {
    return `${baseURL}${SERVICES_PREFIX}`;
  }

  return joinUrl(baseURL, `/api/realms/${realm}`);
};

const api = axios.create({
  baseURL,
  timeout: 1200000,
  headers: {},
});

export default api;
